import React, { useEffect, useState } from "react";
import {
  collection, addDoc, getDocs, updateDoc,
  deleteDoc, doc, query, orderBy, serverTimestamp
} from "firebase/firestore";
import { db } from "../../firebase";

import {
  Box, Typography, Paper, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Button, TextField,
  Dialog, DialogTitle, DialogContent, DialogActions,
  IconButton, TablePagination, InputAdornment
} from "@mui/material";

import { Plus, Search, Edit3, Trash2 } from "lucide-react";
import Swal from "sweetalert2";

function Affiliateproducts() {

  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const [formData, setFormData] = useState({
    id: null,
    productName: "",
    status: "Active"
  });

  // 🔹 Fetch Data
  const fetchData = async () => {
    const q = query(collection(db, "affiliate_products"), orderBy("createdAt", "desc"));
    const snap = await getDocs(q);
    const arr = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    setData(arr);
  };

  useEffect(() => {
    fetchData();
  }, []);

  // 🔹 Save
  const handleSubmit = async () => {

    if (!formData.productName.trim()) {
      return Swal.fire("Error", "Product name required", "error");
    }

    try {
      const payload = {
        productName: formData.productName,
        status: formData.status,
        updatedAt: serverTimestamp()
      };

      if (formData.id) {
        await updateDoc(doc(db, "affiliate_products", formData.id), payload);
      } else {
        await addDoc(collection(db, "affiliate_products"), {
          ...payload,
          createdAt: serverTimestamp()
        });
      }

      setOpen(false);
      resetForm();
      fetchData();

      Swal.fire("Success", "Saved successfully", "success");

    } catch (err) {
      Swal.fire("Error", err.message, "error");
    }
  };

  // 🔹 Delete
  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Delete?",
      showCancelButton: true
    });

    if (confirm.isConfirmed) {
      await deleteDoc(doc(db, "affiliate_products", id));
      fetchData();
    }
  };

  const resetForm = () => {
    setFormData({
      id: null,
      productName: "",
      status: "Active"
    });
  };

  // 🔹 Search
  const filtered = data.filter(d =>
    d.productName?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box p={2}>

      {/* HEADER */}
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography variant="h6">Affiliate Products</Typography>
        <Button
          variant="contained"
          size="small"
          startIcon={<Plus />}
          onClick={() => { resetForm(); setOpen(true); }}
        >
          Add Product
        </Button>
      </Box>

      {/* SEARCH */}
      <TextField
        fullWidth
        size="small"
        placeholder="Search product"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Search size={16} />
            </InputAdornment>
          )
        }}
        sx={{ mb: 2 }}
      />

      {/* TABLE */}
      <Paper>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Sr</TableCell>
                <TableCell>Product Name</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {filtered
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, i) => (
                  <TableRow key={row.id}>
                    <TableCell>{page * rowsPerPage + i + 1}</TableCell>
                    <TableCell>{row.productName}</TableCell>

                    <TableCell>
                      <span style={{
                        color: row.status === "Active" ? "green" : "red",
                        fontWeight: "600"
                      }}>
                        {row.status}
                      </span>
                    </TableCell>

                    <TableCell>
                      <IconButton onClick={() => {
                        setFormData(row);
                        setOpen(true);
                      }}>
                        <Edit3 size={16} />
                      </IconButton>

                      <IconButton onClick={() => handleDelete(row.id)}>
                        <Trash2 size={16} />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          count={filtered.length}
          page={page}
          rowsPerPage={rowsPerPage}
          onPageChange={(e, newPage) => setPage(newPage)}
          onRowsPerPageChange={(e) => {
            setRowsPerPage(parseInt(e.target.value, 10));
            setPage(0);
          }}
        />
      </Paper>

      {/* MODAL */}
      <Dialog open={open} onClose={() => setOpen(false)} fullWidth maxWidth="xs">
        <DialogTitle>{formData.id ? "Edit Product" : "Add Product"}</DialogTitle>

        <DialogContent>

          <TextField
            label="Product Name"
            size="small"
            fullWidth
            sx={{ mt: 2 }}
            value={formData.productName}
            onChange={(e) => setFormData({ ...formData, productName: e.target.value })}
          />

          <TextField
            select
            label="Status"
            size="small"
            fullWidth
            sx={{ mt: 2 }}
            value={formData.status}
            onChange={(e) => setFormData({ ...formData, status: e.target.value })}
            SelectProps={{ native: true }}
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </TextField>

        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpen(false)}>Cancel</Button>
          <Button variant="contained" onClick={handleSubmit}>Save</Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
}

export default Affiliateproducts;